import { EmployeeAPIModel } from '../../models/api.model'

export interface EmployeeState extends EmployeeAPIModel {}

export const initialEmployeeState: EmployeeState = {
  id: '',
  createdBy: undefined,
  updatedBy: undefined,
  status: undefined,
  employeeCode: undefined,
  companyEntityId: undefined,
  companyGroupId: undefined,
  firstName: undefined,
  middleName: undefined,
  lastName: undefined,
  doj: undefined,
  role: undefined,
  gender: undefined,
  dob: undefined,
  nationality: undefined,
  emailId: undefined,
  secondaryEmailId: undefined,
  mobileNumber: undefined,
  alternateMobileNumber: undefined,
  address: undefined,
  maritalStatus: undefined,
  passwordAutoGenerated: undefined,
  passwordExpirationDate: undefined,
  notificationPreferences: undefined,
  employeeEmploymentBasicDetails: undefined,
  employeeStatutoryDetails: undefined,
  employeeComplianceReferenceDetailsModel: undefined,
  employeeBankDetailModel: undefined
}
